import React from "react";
import Fab from "@mui/material/Fab";
import makeStyles from "@mui/styles/makeStyles";
import IconCookie from "@mui/icons-material/Cookie";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: theme.zIndex.drawer + 2,
    position: "absolute",
    bottom: "0.5em",
    left: "0.5em",
  },
}));

/**
 * This component is responsible for rendering a floating action button
 * allowing the visitor to reconsider their cookie consent decision.
 *
 * The only relevant interface is that it exposes an onClick event: it is
 * in fact agnostic about what happens next.
 *
 */
export const CookieConsentFab = (props) => {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <Fab
      aria-label={t("Edit cookie preferences")}
      className={styles.root}
      size="small"
      color="secondary"
      variant="circular"
      onClick={props.onClick}
    >
      <IconCookie />
    </Fab>
  );
};
